import * as R from 'rambdax'
import {ensureArray} from 'tizra'
import {useHydration} from './useHydration'

const w = typeof window === 'undefined' ? undefined : window

/**
 * Get a window property, with fallback to defaultValue, and consistency for
 * hydration.
 */
export const useWindow = (path, defaultValue) => {
  return useHydration(
    defaultValue,
    R.pathOr(defaultValue, ensureArray(path), w),
  )
}
